module.exports = __webpack_public_path__ + "img/maitrisez.e5d9ec9b.jpg";